import { render, staticRenderFns } from "./uselist.vue?vue&type=template&id=a31388e8&scoped=true&"
import script from "./uselist.vue?vue&type=script&lang=js&"
export * from "./uselist.vue?vue&type=script&lang=js&"
import style0 from "./uselist.vue?vue&type=style&index=0&id=a31388e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31388e8",
  null
  
)

export default component.exports